import { render, staticRenderFns } from "./AlertsDetails.vue?vue&type=template&id=6c16a317&"
import script from "./AlertsDetails.vue?vue&type=script&lang=js&"
export * from "./AlertsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c16a317')) {
      api.createRecord('6c16a317', component.options)
    } else {
      api.reload('6c16a317', component.options)
    }
    module.hot.accept("./AlertsDetails.vue?vue&type=template&id=6c16a317&", function () {
      api.rerender('6c16a317', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/alerts/AlertsDetails.vue"
export default component.exports